import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomerAgeingApi, getVendorAgeingApi } from "../../../apiservice/accounts";


export const fetchCustomerAgeing = createAsyncThunk(
  "ageing/fetchCustomer",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {
        customerId: filters.customerId || null,
        locationId: filters.locationId || null,
        groupId:    filters.groupId    || null,
      };

      const res = await getCustomerAgeingApi(payload);

      if (res.data) return res.data;
      return rejectWithValue("No data returned");
    } catch (err) {
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }
      return rejectWithValue(
        err.response?.data?.message || err.message || "Failed to fetch customer ageing"
      );
    }
  }
);

export const fetchVendorAgeing = createAsyncThunk(
  "ageing/fetchVendor",
  async (filters, { rejectWithValue }) => {
    try {
      const payload = {
        supplierId: filters.supplierId || null,
      };

      const res = await getVendorAgeingApi(payload);

      if (res.data) return res.data;
      return rejectWithValue("No data returned");
    } catch (err) {
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }
      return rejectWithValue(
        err.response?.data?.message || err.message || "Failed to fetch vendor ageing"
      );
    }
  }
);